import { connect, mapProps, mapReadPretty } from '@formily/react'
import { Radio as AntdRadio } from 'antd'

export const Radio = connect(
  AntdRadio,
  mapReadPretty(AntdRadio, {
    disabled: true
  })
)

export const RadioGroup = connect(
  AntdRadio.Group,
  mapReadPretty(AntdRadio.Group, {
    disabled: true
  }),
  mapProps({
    dataSource: 'options'
  })
)
